import { useQuery } from '@tanstack/react-query';
import { getFavoriteShops, getSellerShop } from '../api';
import { getCustomer } from '../services/customerService';

export function useSellerShop(id) {
  return useQuery({
    queryKey: ['seller-shop', Number(id)],
    queryFn: () => getSellerShop(id).then(({ data }) => data),
    enabled: Number.isSafeInteger(Number(id)) && Number(id) > 0 && Number(id) <= 2147483647,
    retry: (count, error) => error.response?.status !== 404 && count < 1,
  });
}

export function useFavoriteShops() {
  const phone = getCustomer()?.phone;
  return useQuery({
    queryKey: ['favorite-shops', phone],
    queryFn: () => getFavoriteShops().then(({ data }) => data),
    enabled: Boolean(phone && localStorage.getItem('customerAccessToken')),
    retry: false,
  });
}
